"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _jsxRuntime = require("react/jsx-runtime");

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M17 1.5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM22 22c0 .55-.45 1-1 1-1.03 0-2.05-.25-3-.75-1.92 1.02-4.18 1-6.09-.05-1.79.87-3.92.98-5.58-.14C5.3 22.69 4.15 23 3 23c-.55 0-1-.45-1-1s.45-1 1-1c.87 0 1.73-.24 2.53-.7.29-.16.65-.17.94 0 1.59.9 3.48.9 5.06 0 .29-.16.65-.16.94 0 1.59.9 3.48.9 5.06 0 .29-.16.65-.16.94 0 .8.46 1.66.7 2.53.7.55 0 1 .45 1 1zM8.04 18.86c.31.09.63.14.96.14.9 0 1.72-.37 2.39-.91.35-.28.87-.28 1.22 0 .67.54 1.49.91 2.39.91s1.72-.37 2.39-.91c.03-.03.07-.05.11-.07-.46-.39-.97-.79-1.5-1.17v-2.87c0-.61-.28-1.19-.77-1.57L12.17 10l2.25-1.52c1.03 1.79 2.82 3.08 4.93 3.43.6.1 1.14-.39 1.14-1 0-.49-.36-.9-.84-.98-1.5-.25-2.78-1.18-3.51-2.46l-.88-1.55c-.29-.52-.77-.8-1.22-.89l-4.73-.88c-.52-.1-1.06.02-1.5.32L5.82 5.83c-.45.32-.57.94-.26 1.39.32.46.94.58 1.4.27l1.99-1.37 2 .37L8.8 7.94c-.6.41-.89 1.12-.77 1.79l.52 3.1c-1.42-.52-2.72-.83-3.7-.83-.84 0-1.85.25-1.85 1.28 0 1.44 2.19 3.62 5.04 5.58zM14 14v1.5c-.78-.48-2.34-1.33-3.26-1.75l-.44-2.65L14 14z"
}), 'SurfingRounded');

exports.default = _default;